import EIVAPI from "api/eiv";

// Define a consistent color map or fallback colors
const colorPalette = ["primary", "info", "warning", "success", "dark", "secondary", "error"];

const getComplexReportsDoughnutChartData = async (facility, week, year) => {
  try {
    const response = await EIVAPI.GetWeeklyFacilityInsuranceMetrics(facility, week, year);
    const insuranceData = response.data;

    if (!insuranceData || insuranceData.length === 0) return null;

    const labels = insuranceData.map((item) => item.insurance);
    const data = insuranceData.map((item) => Number(item.total_charge || 0));
    const total = data.reduce((sum, val) => sum + val, 0);
    const percentages = data.map((val) => total > 0 ? ((val / total) * 100).toFixed(1) : "0.0");

    const backgroundColors = labels.map((_, index) => colorPalette[index % colorPalette.length]);

    return {
      labels,
      percentages, // 👈 Include percentages if needed elsewhere
      datasets: {
        label: "Total Charges",
        backgroundColors,
        data,
      },
    };
  } catch (error) {
    console.warn("Error loading doughnut chart data", error);
    return null;
  }
};

export default getComplexReportsDoughnutChartData;
